import { render, staticRenderFns } from "./multipleChains.vue?vue&type=template&id=2f8f3237&scoped=true&"
import script from "./multipleChains.vue?vue&type=script&lang=js&"
export * from "./multipleChains.vue?vue&type=script&lang=js&"
import style0 from "./multipleChains.vue?vue&type=style&index=0&id=2f8f3237&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f8f3237",
  null
  
)

export default component.exports